import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from '@material-ui/core';
import { basicService } from '@app/services';
import { getMenuItemLinkByChunk, getMenuItemNameByChunk, getMenuItemById, getMenuItemIdByChunk } from '@app/helpers';
import { mainMenuTop, mainMenuBottom, IMenuItem, menuExtras } from '../Sidebar';
import { UrlChunk, IGlobalState, IBreadcrumb } from '@app/models';
import { useTypedTranslation } from '@app/hooks';

export const Breadcrumbs = () => {
    const [urlChunks, setUrlChunks] = useState<UrlChunk[]>([]);
    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumb[]>([]);
    const [breadcrumbsItem, setBreadcrumbsItem] = useState<(IMenuItem | undefined)[]>([]);
    const detailsBreadcrumb = useSelector((state: IGlobalState) => state.breadcrumbs.details);
    const breadcrumbsArray = useSelector((state: IGlobalState) => state.breadcrumbs.array);

    const { translation } = useTypedTranslation();

    useEffect(() => {
        const url = window.location.pathname;
        setUrlChunks(url.substr(1).split('/'));
    }, [window.location.pathname]);

    useEffect(() => {
        setBreadcrumbsItem([handleBreadcrumbsSource(urlChunks[0])]);
    }, [urlChunks]);

    useEffect(() => {
        if (breadcrumbsArray.length) setBreadcrumbs(breadcrumbsArray);

        else {
            let temp: IBreadcrumb[] = urlChunks
                .filter((chunk: UrlChunk) => handleBreadcrumbName(chunk) !== '')
                .map((chunk: UrlChunk) => {
                    return {
                        name: handleBreadcrumbName(chunk),
                        link: handleBreadcrumbLink(chunk)
                    };

                });

            if (detailsBreadcrumb !== '') temp.push({
                name: detailsBreadcrumb
            });

            setBreadcrumbs(temp);
        }

    }, [breadcrumbsArray, urlChunks, breadcrumbsItem, detailsBreadcrumb]);

    const handleBreadcrumbsSource = (chunk: UrlChunk): IMenuItem | undefined => {
        const getBreadcrumbsItem = (chunk: UrlChunk, menu?: (IMenuItem)[]): IMenuItem | undefined => {
            return getMenuItemById(getMenuItemIdByChunk(chunk, menu), menu);
        };
        return getBreadcrumbsItem(chunk)
            ? getBreadcrumbsItem(chunk) : getBreadcrumbsItem(chunk, mainMenuTop)
                ? getBreadcrumbsItem(chunk, mainMenuTop) : getBreadcrumbsItem(chunk, mainMenuBottom)
                    ? getBreadcrumbsItem(chunk, mainMenuBottom) : getBreadcrumbsItem(chunk, menuExtras)
                        ? getBreadcrumbsItem(chunk, menuExtras) : undefined;
    };

    const handleRedirection = (link: string | undefined) => () =>  {
        basicService.redirect(link);
    };

    const handleBreadcrumbName = (chunk: UrlChunk): string => {
        return translation(getMenuItemNameByChunk(chunk, breadcrumbsItem));
    };

    const handleBreadcrumbLink = (chunk: UrlChunk | undefined): string | undefined => {
        return chunk ? getMenuItemLinkByChunk(chunk, breadcrumbsItem) : undefined;
    };

    const getTextClass = (index: number): string => {
        return breadcrumbs.length === index + 1 ? 'breadcrumbs__text-last' : '';
    };

    return (
        <div className='breadcrumbs'>
            <div className='breadcrumbs__text'>
                {breadcrumbs.map((breadcrumb: IBreadcrumb, index: number) => (
                    <React.Fragment key={index}>
                        {index !== 0 && <span> / </span>}
                        {(breadcrumb.link && breadcrumbs.length !== index + 1)
                            ? <Link onClick={handleRedirection(breadcrumb.link)}>{breadcrumb.name}</Link>
                            : <span className={getTextClass(index)}>{breadcrumb.name}</span>
                        }
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};
